import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography , Select , MenuItem } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import moment from 'moment-timezone';
import { CUSTOM_CONSTANTS } from "Constants";

//Services
import DriverApi from "Services/Driver"

const Cashoutsheets = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const timezone = useSelector((state) => state.timezone.timezone);
  //Pagination
  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [statusMap, setStatusMap] = useState({});
  //Modals

  // Get userWallet list api
  const getcashoutsheets = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
       console.log('cashout-records-->',res?.data?.data?.data);
        const cashoutData = res?.data?.data?.data || [];

        setRow(cashoutData);

        // Build statusMap from fetched data
        const newStatusMap = {};
        cashoutData.forEach((item) => {
          newStatusMap[item._id] = item.status;
        });
        setStatusMap(newStatusMap);

      } else {
        setRow([]);
        setStatusMap({});
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    DriverApi
      .getdriverscashoutsheets({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  useEffect(() => {
    getcashoutsheets();
  }, [getcashoutsheets]);

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

const dataRows = _.map(
  (row || []).filter(data => data?.docpath), // Filter out rows with empty or undefined username
  (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    dateofcreation: data?.date,
    status: data?.status,
    sheetpath: data?.docpath,
    updatedAt:moment(data?.updatedAt).tz(timezone).format("YYYY-MM-DD hh:mm A"),
    row: data,
  }));
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "dateofcreation",
      headerName: "Date of creation",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
          <Typography variant="body2"  
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontWeight:"bold",
            color: "#0c060eff", // Optional: Color to indicate it's clickable
          }}>{params?.row?.dateofcreation}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex:1,
      sortable: true,
      renderCell: (params) => {
    const rowId = params.row.row._id;
    const currentStatus = statusMap[rowId] || "PENDING";
    const getColor = (status) => {
      switch (status) {
        case "PAID":
          return "#04a571";
        case "REJECTED":
          return "#cb0202"; // mild red
        case "PENDING":
        default:
          return "#ed6c02"; // orange (pending)
      }
    };
      return (
      <Select
        value={currentStatus}
        onChange={(e) => handleStatusChange(rowId, e.target.value)}
        variant="standard"
        size="small"
        sx={{ minWidth: 120 , color: getColor(currentStatus) }}
      >
        <MenuItem value="PENDING" sx={{ color: "#ed6c02" }} >PENDING</MenuItem>
        <MenuItem value="PAID" sx={{ color: "#04a571" }} >PAID</MenuItem>
        <MenuItem value="REJECTED" sx={{ color: "#cb0202" }} >REJECTED</MenuItem>
      </Select>
    );
      },
    },
    {
      field: "sheetpath",
      headerName: ".XlSX",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        const downloadUrl = params?.row?.sheetpath;

        return (
           <>
        {downloadUrl ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<DownloadIcon />}
          >
            Download
          </Button>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No file
          </Typography>
        )}
      </>
        );
      },
    }, 
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.updatedAt}</Typography>
            </div>
          </>
        );
      },
    },      
  ];

  const handleStatusChange = async (id, newStatus) => {

  dispatch(showLoader("Loading please wait..."));
  // Optimistically update UI
  setStatusMap((prev) => ({
    ...prev,
    [id]: newStatus,
  }));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
      getcashoutsheets();
      } else {

        const originalStatus = row.find((r) => r._id === id)?.status || "PENDING";
        setStatusMap((prev) => ({
          ...prev,
          [id]: originalStatus,
        }));
             getcashoutsheets();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to update data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    DriverApi.updatedrivercashoutsheets( id, { status: newStatus }).then(onSuccess, onFailure);
  }

  return (
    <>
        <Grid container className={classes.walletdetails}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
            />
          </section>
        </Grid>
      </Grid>
    </>
  );
};

export default Cashoutsheets;
